import { Task } from '../types'

export const isProject = (task: Task) =>
	('childCount' in task &&
		(task?.childCount.active || task?.childCount.inactive)) ||
	task?.isProject ||
	(task?.childSortOrder && task?.childSortOrder.length)
